var render, staticRenderFns
import script from "./codeComponent.vue?vue&type=script&lang=js&"
export * from "./codeComponent.vue?vue&type=script&lang=js&"
import style0 from "./codeComponent.vue?vue&type=style&index=0&id=35b88732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b88732",
  null
  
)

export default component.exports